import { render, staticRenderFns } from "./PremiumModal.vue?vue&type=template&id=6ed4e074&"
import script from "./PremiumModal.vue?vue&type=script&lang=ts&"
export * from "./PremiumModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports